// Export Sortable Element Handle Directive
export const HandleDirective = {
  bind(el) {
    el.sortableHandle = true;
  },
};
